<template>
    <v-container fluid class="pt-0">
        <v-row>

            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-handshake</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Registro total de asociaciones</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ partnerships.length }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>

            <v-col cols="12" lg="9" style="position:relative; top: -60px">
                <v-card>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :loading="loading"
                            :footer-props="footer_props"
                            :loading-text="loading_text"
                            :no-data-text="no_data_text"
                            :no-results-text="no_result_text"
                            :search="search"
                        >
                        <template v-slot:top>
                                <v-container class="py-0">
                                    <v-row justify="center" align="center">
                                        <v-col cols="12" lg="6">

                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" @click="create_dialog = !create_dialog" dark>
                                                        <v-icon>mdi-plus-circle</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Nuevo registro</span>
                                            </v-tooltip>

                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" dark>
                                                        <v-icon>mdi-file-pdf</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Exportar</span>
                                            </v-tooltip>

                                        </v-col>
                                        <v-col cols="12" lg="6">
                                            <v-text-field
                                                v-model="search"
                                                clearable
                                                dense
                                                outlined
                                                hide-details
                                                label="Buscar"
                                                append-icon="mdi-magnify"
                                                color="#818181"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template v-slot:item.status="{ item }">
                                {{ item.status == 1 ? 'Activo' : 'Inactivo' }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-menu</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-item class="px-0">
                                            <v-list-item-content>
                                                <v-btn small text>Mostrar</v-btn>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="px-0">
                                            <v-list-item-content>
                                                <v-btn small text>Editar</v-btn>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="px-0">
                                            <v-list-item-content>
                                                <v-btn small text>Eliminar</v-btn>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="px-0">
                                            <v-list-item-content>
                                                <v-btn small text @click="() => { item_dialog = item; billing_dialog = !billing_dialog }">Facturación</v-btn>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <create :dialog="create_dialog" :store_url="store_url"></create>
        <billing :dialog="billing_dialog" :item="item_dialog"></billing>

    </v-container>
</template>
<script>

import create from './create'
import billing from './billing'

export default {
    props:['partnerships'],
    components:{
        create,
        billing
    },
    data: () => ({
        //items
        items:[],
        item_dialog:"",

        //urls
        store_url:"/partnerships/store",

        //dialogs
        create_dialog:false,
        billing_dialog:false,

        //data table props
        color:"#818181",
        search:"",
        loading:false,
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'Folio', value:'folio' },
            { text:'Nombre de página', value:'partnership.pagename' },
            { text:'Nombre', value:'name' },
            { text:'Correo electrónico', value:'email' },
            { text:'Enlace', value:'partnership.link' },
            { text:'status', value:'status' },
            { text: 'Acciones', value:'actions', sorteable:false}
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        }
    }),

    created(){
        this.items = this.partnerships
    },

    methods:{
        getData:function(){
            this.loading = "#008dd4"
            axios.get("/partnerships").then(response =>{
                this.items = response.data.partnerships
            }).catch(error => {
                console.log(error.response.data)
            })
            this.loading = false
        }
    }
}
</script>